// ----------------------------------------------------------------------------
// Nombre del Programa : Comunicado
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones el listado de comunicados
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Se modificaron etiquetas 20/AGO/2024
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import './Comunicados.scss';
import 'react-status-alert/dist/status-alert.css';
import { useEffect, useState } from 'react';
import { apiRequestToken } from '../../Utilidades/apiRequest';
import { Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { StatusAlertService } from 'react-status-alert';
import Simplert from 'react-simplert';
import { Paginador } from '../../components/paginador/Paginador';
import { ComunicadosProps } from '../../interfaces/comunicadosInterfaces';
import { getComunicados, deleteComunicados } from '../../Services/ComunicadosService';

export const Comunicados = () => {
  const PAGE_SIZE = 8;
  const [pagActual, setPagActual] = useState<number>(0);

  const [comunicados, setComunicados] = useState<ComunicadosProps[]>([]);
  const [cargado, setCargado] = useState<boolean>(false);
  const [mostrarAlerta, setMostrarAlerta] = useState<boolean>(false);
  const [comunicadoBorrar, setComunicadoBorrar] = useState<{
    idp: number;
    index: number;
  }>({
    idp: 0,
    index: 0,
  });

  useEffect(() => {
    getComunicados().then((response) => {
      if (response.data && response.data.data) {
        setComunicados(response.data.data);
        setCargado(true);
      }
    });
  }, []);

  const borrarComunicado = async (idp: number, index: number) => {
    let indexBorrar = pagActual * PAGE_SIZE + index;
    setComunicadoBorrar({ idp: idp, index: indexBorrar });
    setMostrarAlerta(true);
  };
  const confirmarBorrarComunicado = async () => {
    setMostrarAlerta(false);
    setCargado(false);
    const response: any = await deleteComunicados(comunicadoBorrar.idp).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
      setCargado(true);
    });
    if (response.data && response.data.data) {
      comunicados.splice(comunicadoBorrar.index, 1);
      setCargado(true);
      StatusAlertService.showSuccess('Borrado Exitosamente');
    }
  };

  const comunicadosMostrar = () =>
    comunicados.filter(
      (_, i) =>
        i >= PAGE_SIZE * pagActual && i <= PAGE_SIZE * pagActual + PAGE_SIZE - 1
    );

  const cambiarPagina = (pag) => {
    setPagActual(pag);
  };

  return (
    <>
      <Simplert
        showSimplert={mostrarAlerta}
        type="info"
        title="¿Desea Eliminarlo?"
        message=""
        customCloseBtnText="Cancelar"
        customConfirmBtnText="Aceptar"
        customConfirmBtnClass="btn-confirm"
        customCloseBtnClass="btn-cerrar"
        disableOverlayClick={true}
        useConfirmBtn={true}
        onConfirm={() => confirmarBorrarComunicado()}
        onClose={() => setMostrarAlerta(false)}
      />
      <div className="m-5">
        <Row>
          <Col className="heading-1">Comunicados</Col>
        </Row>
        <div className="d-flex flex-row-reverse bd-highlight mb-3">
          <Link to={'/comunicados/comunicado/0'}>
            <Button variant="primary" className="float-end">
              Crear nuevo comunicado
            </Button>
          </Link>
        </div>
        <Table responsive>
          <thead className="colorgray2">
            <tr>
              <th>Titulo</th>
              <th>Fecha de creación</th>
              <th>Fecha de publicación</th>
              <th>Fecha de cierre</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {comunicados.length > 0 ? (
              comunicadosMostrar().map((comunicado, index) => (
                <tr key={comunicado.comunicado_id} className="colorgray2">
                  <td
                    className={
                      index === 0
                        ? ''
                        : index === comunicados.length - 1
                          ? ''
                          : ''
                    }
                  >
                    {comunicado.titulo}
                  </td>
                  <td>{moment(comunicado.fecInserta).format('DD/MM/YYYY')}</td>
                  <td>
                    {moment(comunicado.fechaPublicacion).format('DD/MM/YYYY')}
                  </td>
                  <td>
                    {comunicado.fechaCierre
                      ? moment(comunicado.fechaCierre).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td
                    className={
                      index === 0
                        ? ''
                        : index === comunicados.length - 1
                          ? ''
                          : ''
                    }
                    width="210"
                  >
                    <Button
                      variant="secondary"
                      className="btntable me-2"
                      onClick={() =>
                        borrarComunicado(comunicado.comunicado_id, index)
                      }
                    >
                      <div className="material-icons">delete</div>
                    </Button>
                    <Link
                      to={'/comunicados/comunicado/' + comunicado.comunicado_id}
                    >
                      <Button variant="secondary" className="btntable me-2">
                        <div className="material-icons">edit</div>
                      </Button>
                    </Link>
                    <Link to={'/vista-comunicado/' + comunicado.comunicado_id}>
                      <Button variant="secondary" className="btntable">
                        <div className="material-icons">visibility</div>
                      </Button>
                    </Link>
                  </td>
                </tr>
              ))
            ) : cargado ? (
              <tr className="colorgray2">
                <td className="nodatos    " colSpan={5}>
                  No Existen Datos
                </td>
              </tr>
            ) : (
              <tr></tr>
            )}
          </tbody>
        </Table>
        <Row>
          <Paginador
            tamanoPagina={PAGE_SIZE}
            totalRegistros={comunicados.length}
            paginaCambiada={cambiarPagina}
          ></Paginador>
        </Row>
      </div>
    </>
  );
};
